import axios from "axios";

const ENDPOINT_PATH =
  process.env.VUE_APP_API_URL || "https://apps.bancojulio.com.ar:6698/api/";
const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY || "";
const ANTI_BOT_SECRET =
  process.env.VUE_APP_ANTI_BOT_SECRET ||
  "PF_WEB_CLIENT_SECRET_V1_DEV_32CHARS_MIN";
const CLIENT_VERSION = "2.0";

const apiClient = axios.create({
  validateStatus: () => true,
});

let recaptchaPromise;

function generateRequestId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
    char,
  ) {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function getCommonHeaders(timestamp = Date.now()) {
  return {
    "Content-Type": "application/json",
    "X-Client-Version": CLIENT_VERSION,
    "X-Request-ID": generateRequestId(),
    "X-Timestamp": timestamp.toString(),
  };
}

async function sha256Hex(message) {
  if (!window.crypto || !window.crypto.subtle) {
    throw new Error("El navegador no soporta la API criptografica requerida.");
  }

  const data = new TextEncoder().encode(message);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

function loadRecaptcha() {
  if (!RECAPTCHA_SITE_KEY) {
    return Promise.reject(
      new Error("Falta configurar VUE_APP_RECAPTCHA_SITE_KEY."),
    );
  }

  if (window.grecaptcha && window.grecaptcha.execute) {
    return Promise.resolve(window.grecaptcha);
  }

  if (!recaptchaPromise) {
    recaptchaPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(
        RECAPTCHA_SITE_KEY,
      )}`;
      script.async = true;
      script.defer = true;
      script.onload = () =>
        window.grecaptcha.ready(() => resolve(window.grecaptcha));
      script.onerror = () => reject(new Error("No se pudo cargar reCAPTCHA."));
      document.head.appendChild(script);
    });
  }

  return recaptchaPromise;
}

async function getCaptchaToken(action) {
  const grecaptcha = await loadRecaptcha();
  return grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
}

async function getAntiBotToken(body, timestamp) {
  const mensaje = `${timestamp}|${JSON.stringify(body)}|${ANTI_BOT_SECRET}`;
  const signature = await sha256Hex(mensaje);

  return {
    timestamp,
    signature,
  };
}

async function postSecured(endpoint, body, captchaAction) {
  const captchaToken = await getCaptchaToken(captchaAction);
  const securedBody = {
    ...body,
    captchaToken,
  };
  const timestamp = Date.now();
  const antiBotToken = await getAntiBotToken(securedBody, timestamp);
  const headers = {
    ...getCommonHeaders(timestamp),
    "X-Anti-Bot-Token": JSON.stringify(antiBotToken),
  };

  return apiClient.post(ENDPOINT_PATH + endpoint, securedBody, { headers });
}

function getWithCommonHeaders(endpoint, config = {}) {
  return apiClient.get(ENDPOINT_PATH + endpoint, {
    ...config,
    headers: {
      ...getCommonHeaders(),
      ...(config.headers || {}),
    },
  });
}

export default {
  register(solicitud) {
    return postSecured("solicitudpf", solicitud, "solicitudpf");
  },
  confirm(solicitud) {
    return postSecured("confirmarpf", solicitud, "confirmarpf");
  },
  consultar(parametros) {
    return getWithCommonHeaders("consultarpf", parametros);
  },
};
